import { render } from "./Skills.vue?vue&type=template&id=b025ab2a"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import exportComponent from "/Users/roms/PhpstormProjects/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__